export default __webpack_public_path__ + "static/acquisition-background-4dc4668555808a1645caa8892b5b1e45.jpg";